import { render, staticRenderFns } from "./unit-list.vue?vue&type=template&id=4b5919fc&"
import script from "./unit-list.vue?vue&type=script&lang=js&"
export * from "./unit-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports